import React from 'react';
import DateTimeCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/date-time-cell';
import PatchDateTimeCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-date-time-cell';
import KbNumberCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/kb-number-cell';
import PatchActionsCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-actions';
import PatchCategoryCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-category-cell';
import PatchCountCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-count';
import PatchSeverityCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-severity-cell';
import PatchStatusCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-status-cell';
import PatchNameCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/patch-name-cell';
import { TextCell } from '@nile/rmm/src/modules/scripts/components/cells';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';
import ApprovalByDetailsCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/ApprovalByDetailsCell';
import NumberCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/number-cell';
import FailureCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/Failure-cell/index.js';
import CVSSScoreCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/cvss-score-cell/index.js';
import VersionCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/version-cell/index.js';
import SizeTextCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/size-text-cell/index.js';
import RollbackCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/rollback-cell';
import CombinedSeverityCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/combined-severity-cell';

const columnsConfig = {
  minWidth: 30,
  maxWidth: 500,
  width: 300,
  TYPE: AssetTypeCell,
  TEXT: TextCell,
  ACTIONS: PatchActionsCell,
  COUNT: PatchCountCell,
  KBNUMBER: KbNumberCell,
  PATCHSTATUSCELL: PatchStatusCell,
  PATCHSEVERITYCELL: PatchSeverityCell,
  PATCHCATEGORYCELL: PatchCategoryCell,
  DATETIME: DateTimeCell,
  TITLE: PatchNameCell,
  ApprovalByDetailsCell,
  NUMBER: NumberCell,
  FAILURECELL: FailureCell,
  PATCHDATETIME: PatchDateTimeCell,
  CVSSSCORECELL: CVSSScoreCell,
  VERSION: VersionCell,
  SIZE: SizeTextCell,
  ROLLBACKCELL: RollbackCell,
  SENTIMENTSEVERITY: (props) => (
    <CombinedSeverityCell {...props} severityType="sentiment" />
  ),
  KNOWNISSUESSEVERITY: (props) => (
    <CombinedSeverityCell {...props} severityType="knownIssues" />
  ),
  STABILITYSEVERITY: (props) => (
    <CombinedSeverityCell {...props} severityType="stability" />
  )
};

const getAttributeName = (column) => {
  switch (column?.name) {
    case 'kbNumbers':
      return 'kbNumbers.kbNumber';
    case 'patchDetail.kbNumbers':
      return 'patchDetail.kbNumbers.kbNumber';
    default:
      return column?.name;
  }
};

// patchDetail.version
const getColumnWidth = (colName, isMinWidth = false) => {
  switch (colName) {
    case 'title':
    case 'patchDetail.title':
      return 400;
    case 'approvalStatus':
    case 'patchDetail.approvalStatus':
      return 160;
    case 'patchDetail.actionType':
      return 200;
    case 'installationStatus':
    case 'patchDetail.installationStatus':
      return 320;
    default:
      return isMinWidth ? 50 : 180;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'patchDetail.title':
    case 'title':
      return 'TITLE';
    case 'approvalStatus':
    case 'patchDetail.approvalStatus':
    case 'patchDetail.actionType':
    case 'patchDetail.action':
      return 'ACTIONS';
    case 'totalDeviceCount':
    case 'failedDeviceCount':
    case 'installedDeviceCount':
    case 'associatedAssets':
      return 'COUNT';
    case 'kbNumbers':
    case 'patchDetail.kbNumbers':
    case 'patchDetail.kbNumbers.kbNumber':
      return 'KBNUMBER';
    case 'installationStatus':
      return 'PATCHSTATUSCELL';
    case 'patchDetail.severity':
    case 'severity':
      return 'PATCHSEVERITYCELL';
    case 'patchDetail.category':
    case 'category':
      return 'PATCHCATEGORYCELL';
    case 'patchDetail.publishedDate':
    case 'publishedDate':
      return 'PATCHDATETIME';
    case 'approvalTime':
    case 'installationTime':
    case 'discoveredTime':
      return 'DATETIME';
    case 'approvalByDetails':
      return 'ApprovalByDetailsCell';
    case 'failedPercent':
    case 'installedPercent':
    case 'rebootRequiredPercent':
      return 'NUMBER';
    case 'failedMessage':
      return 'FAILURECELL';
    case 'patchDetail.maxCVSSScore':
    case 'patchDetail.maxCVSSDetail.cvssScore':
      return 'CVSSSCORECELL';
    case 'patchDetail.version':
    case 'version':
      return 'VERSION';
    case 'patchDetail.size':
    case 'size':
      return 'SIZE';
    case 'newOrMissingDeviceCount':
    case 'rebootRequiredDeviceCount':
    case 'newormissing':
      return 'COUNT';
    case 'patchDetail.patchUninstallable':
    case 'assetUninstallable':
      return 'ROLLBACKCELL';
    case 'globalPatchDetail.sentimentSeverity':
      return 'SENTIMENTSEVERITY';
    case 'globalPatchDetail.knownIssuesSeverity':
      return 'KNOWNISSUESSEVERITY';
    case 'globalPatchDetail.stabilitySeverity':
    case 'patchDetail.stabilitySeverity':
      return 'STABILITYSEVERITY';
    default:
      return 'TEXT';
  }
};

const getAccessor = (col) => {
  if (col.name === 'patchDetail.actionType') {
    return 'approvalActions';
  }
  return col.name;
};
const getValueSuffix = (col) => {
  switch (col.name) {
    case 'failedPercent':
    case 'installedPercent':
    case 'rebootRequiredPercent':
      return '%';
    default:
      return '';
  }
};

export {
  getAttributeName,
  getColumnWidth,
  getType,
  getAccessor,
  columnsConfig,
  getValueSuffix
};
